// src/admin/hooks/useAdBanners.js

import { useEffect, useState } from "react";

import { bannerService } from "../services/bannerService";

export default function useBanners(search = "") {

    const [banners, setBanners] = useState([]);

    const [loading, setLoading] = useState(true);

    const [deletingId, setDeletingId] = useState(null);

    const [saving, setSaving] = useState(false);

    useEffect(() => {

        const timeout = setTimeout(() => {
            fetchBanners();
        }, 400);

        return () => clearTimeout(timeout);

    }, [search]);

    const fetchBanners = async () => {

        try {

            setLoading(true);

            const data =
                await bannerService.getBanners(search);

            setBanners(data.results || []);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    const getBanner = async (id) => {

        try {

            return await bannerService.getBanner(id);

        } catch (error) {

            console.error(error);

            throw error;

        }

    };

    const createBanner = async (data) => {

        setSaving(true);

        try {

            await bannerService.createBanner(data);

            await fetchBanners();

        } catch (error) {

            console.error(error.response?.data);

        } finally {

            setSaving(false);

        }

    };

    const updateBanner = async (id, data) => {

        setSaving(true);

        try {

            await bannerService.updateBanner(id, data);

            await fetchBanners();

        } catch (error) {

            console.error(error);

        } finally {

            setSaving(false);

        }

    };

    const deleteBanner = async (id) => {

        const confirmed = window.confirm(
            "Are you sure you want to delete this banner?"
        );

        if (!confirmed) return;

        try {

            setDeletingId(id);

            setBanners(prev =>
                prev.filter(banner => banner.id !== id)
            );

            await bannerService.deleteBanner(id);

        } catch (error) {

            console.error(error);

            // Restore the list if deletion fails.
            await fetchBanners();

        } finally {

            setDeletingId(null);

        }

    };

    return {

        banners,

        loading,

        saving,

        deletingId,

        fetchBanners,

        getBanner,
        
        createBanner,

        updateBanner,

        deleteBanner,

    };

}